import { createContext } from "react";
import { AuthState, AuthContextType } from "../types/auth";

// Re-export for backward compatibility
export type { AuthState, AuthContextType };

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
